
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import noData from 'assets/images/noData.svg'

function Nodata() {

    return (
        <>

            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        overflow: 'auto',
                        padding: '30px',
                        "@media (max-width: 800px)": {
                            margin: '0px',
                            padding: '15px',
                        }
                    }}>
                        <Box sx={{ display: 'grid', justifyItems: 'center' }}>
                            <Typography sx={{ fontWeight: 600, color: '#478F96' }}>ไม่พบข้อมูล</Typography>
                            <img className={styles.noData} src={noData} />
                        </Box>
                    </Box>
            
            </Box >
        </>
    )
}

export default Nodata